import { render, staticRenderFns } from "./BundleManagementPage.vue?vue&type=template&id=07e23d0f&scoped=true"
import script from "./BundleManagementPage.vue?vue&type=script&lang=js"
export * from "./BundleManagementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e23d0f",
  null
  
)

export default component.exports